import React, { useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getNavigateUrl, navigateToUrl } from "./navigateLinkUtils";
import classes from "./NavigateLink.module.css";

const NavigateLink = ({ link, asElement = "link", target = "_blank", children, checkLogin, auto = false, showLoadingPage = true, className = "", onClick, state, ga }) => {
    const { isAuth } = useSelector(state => state.auth);
    const { lang } = useSelector(state => state.translate);
    const { domainName } = useParams();
    const navigate = useNavigate();
    const autoOpenedRef = useRef(false);
    //קוד זה נעשה בשביל פיננסית צריך תשתית חזקה יותר
    const resolvedLink = lang && link?.includes("<lang>") ? link.replaceAll("<lang>", lang) : link;
    const finalTarget = resolvedLink?.startsWith("http") ? "_blank" : target;
    const checkAuth = checkLogin ?? !isAuth;
    const resolvedGa = ga ? { ...ga, sectionValue: ga.sectionValue ?? domainName } : undefined;
    const url = getNavigateUrl({ link: resolvedLink, checkAuth, showLoadingPage, ga: resolvedGa });

    useEffect(() => {
        if (!auto || !resolvedLink?.startsWith("http") || autoOpenedRef.current)
            return;
        autoOpenedRef.current = true;
        window.open(url, "_blank");
    }, [auto, resolvedLink, url]);

    return (
        url && !auto ?
            asElement === "button" ?
                <button type="button" className={className} onClick={(event) => navigateToUrl({ event, url, finalTarget, navigate, onClick, state })}>
                    {children}
                </button>
                :
                url?.startsWith("http") ?
                    <a href={url} target={finalTarget} rel={showLoadingPage ? "opener" : "noopener"} className={classes.Link} onClick={onClick}>
                        {children}
                    </a>
                    :
                    <Link to={url} state={state} className={classes.Link} onClick={onClick}>
                        {children}
                    </Link>
            :
            !url ?
                children
                :
                null
    );
};

export default NavigateLink;
